module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAABQUlEQVQ4T83TsUtWYRTH8c9rhKBEUyAtoovUUJvgJC5CtAgiiKC0N7SEk4KD4NLSfxC2iNLyYiAiiBI4O0UOWosETSG2iCInzguPV+/rJHiXe3nO7/mec37n3Ib65zEW8Qsf6mSNNoBnmMcfvLtzwEOcVbLcVsH/O9HCHJ5iBbsFpA7wCBMYiTsBWEJvXjzEMg5QBXTgFcbQnfpmALowjlE8yMA37ONtmvgJ0+jJ+AlWsV1OIdoI0cs2kznHJr7gX+huGuMLzKQvJSsq+ozj8vAmwBAm8aRSyY/056gO0JeZB1IQ5bY8Kb93cmJ/Wy3EykbG4YK8h63cxDiexRs8T80pmtiIFj4W5f7MPr/nWcTimcr3YCZrTeNrAN6jH2uI8i5SHB5UARGKDYx9eI31dj9THeCKt/cb0IkF/C68uLaklz0sQWVdc+YvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/perfix.png
// module id = oPPq
// module chunks = 1